import { Dayjs } from 'dayjs'

import dayjs from 'utils/dayjs'

export const getTimeUtcOffset10 = (date?: Dayjs) =>
  dayjs(date).utc().utcOffset(10)
